import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { UpdatePasswordPost } from 'src/types/shared/AdminUser';

export const updateSuperAdminUserPasswordRequest = createAction(
    'updateSuperAdminUserPasswordRequest',
);
export const updateSuperAdminUserPasswordSuccess = createAction(
    'updateSuperAdminUserPasswordSuccess',
);
export const updateSuperAdminUserPasswordFailure = createAction(
    'updateSuperAdminUserPasswordFailure',
);

export const updateSuperAdminUserPassword = (id: number, postbody: UpdatePasswordPost) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(updateSuperAdminUserPasswordRequest());
    try {
        await api.post(`admin/superadmins/${id}/password`, postbody);

        dispatch(updateSuperAdminUserPasswordSuccess());
    } catch (e) {
        handleApiErrors(dispatch, updateSuperAdminUserPasswordFailure, e);
    }
};
